import React, { useEffect, useState } from "react";
import { Modal, Col, Row } from "react-bootstrap";
import { roundMultiplierDetailsApi } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT } from "helpers/common";
import { FadeLoader } from "react-spinners";

export default function RoundMultiplierModal({ show, handleClose, id }) {
  const { loading } = useSelector(({ Jackpot }) => Jackpot);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchData = () => {
    dispatch(
      roundMultiplierDetailsApi({
        data: { _id: id }, // ✅ FIXED

        callBack: (err, response) => {
          const game = response?.data;

          if (game?._id) {
            setData(game);
            console.info("Round Multiplier data ------->", game);
          }
        },
      }),
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold">Round Multiplier Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <FadeLoader />
          </div>
        ) : (
          <section className="section">
            <div className="card">
              <Row>
                <Col lg="12" className="my-2 px-4">
                  <ul className="list-unstyled ps-0 mb-0 mt-3 row">
                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Round Type</p>
                      <p>{data?.roundType || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Energy Spent</p>
                      <p>{data?.energySpent || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Btnc Reward</p>
                      <p>{data?.btncRewardReceived || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Coin Reward</p>
                      <p>{data?.coinRewardReceived || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Jackpot Reward</p>
                      <p>{data?.jackpotRewardReceived || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">
                        Leaderboard Points
                      </p>
                      <p>{data?.leaderboardPointsEarned || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">User Count</p>
                      <p>{data?.userCount ?? 0}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Status</p>
                      <p>{data?.status?.toUpperCase() || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Short Description</p>
                      <p>{data?.shortDescription || "--"}</p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Created At</p>
                      <p>
                        {data?.date_created_utc
                          ? DATE_FORMAT(data.date_created_utc)
                          : "--"}
                      </p>
                    </li>

                    <li className="col-lg-4 col-sm-6 my-2">
                      <p className="mb-0 font-weight-bold">Updated At</p>
                      <p>
                        {data?.date_modified_utc
                          ? DATE_FORMAT(data.date_modified_utc)
                          : "--"}
                      </p>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </section>
        )}
      </Modal.Body>
    </Modal>
  );
}
